// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"AppCookieBanner_cookieBanner__2CtBi","cookieBannerText":"AppCookieBanner_cookieBannerText__1zutF"};